import React from "react";
import { useTranslation } from "react-i18next";
import LibraryScreen from "../../components/screens/Library/LibraryScreen";
import navigation from "../../_nav";

function Library() {
  const { t } = useTranslation();
  return <LibraryScreen t={t} links={navigation.sideNav[1].links} />;
}

Library.propTypes = {};

export default Library;
